import mutations from './occupationHealthReport.mutations'
import actions from './occupationHealthReport.actions'
import getters from './occupationHealthReport.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
